/** A weight from a form field, in kg, rounded to 0.1 kg: the scale of
 *  `tournament_weighins.weight_kg` (NUMERIC(5,1)), as the server rounds it
 *  (#549 review). A comma is a decimal point. Empty, not a number, or 0 after
 *  the rounding gives null. #556 — the Weigh-in tab and the Check-in desk
 *  share it, so the class that a desk picks comes from the weight that the
 *  row stores: 71.04 is 71.0, which is not over a -71 class. */
export function toKg(v: number | string | null | undefined): number | null {
  if (v == null || v === '') return null;
  const n = typeof v === 'number' ? v : Number(String(v).trim().replace(',', '.'));
  if (!Number.isFinite(n)) return null;
  const kg = Math.round(n * 10) / 10;
  return kg > 0 ? kg : null;
}

/** The weight of an athlete as a screen shows it: "70 kg". The ONE rule of
 *  the unit and the guard (#552, #608): `Number()` turns the NUMERIC string
 *  "70.0" into "70", and a missing weight or 0 gives null, so a row shows
 *  nothing and never "0 kg". The limit of a weight class or of a ring is not
 *  the weight of an athlete: it keeps its own text. */
export function weightText(v: number | string | null | undefined): string | null {
  const kg = Number(v);
  return kg > 0 ? `${kg} kg` : null;
}
